import React from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import { ArrowRight } from "@phosphor-icons/react";
import Seo from "@/components/Seo";

const steps = [
  { num: "01", title: "Tell Us Where You Are", desc: "Share your context, school, university, career, transition." },
  { num: "02", title: "Choose Your Mentor", desc: "Browse mentor profiles by pathway, availability and language." },
  { num: "03", title: "Choose Your Session Type", desc: "Career strategy, application construction, mock interview, more." },
  { num: "04", title: "Choose Your Level of Support", desc: "Single session or a structured programme, First Mile, Crossing, Horizon." },
  { num: "05", title: "Move Forward with Confidence", desc: "Action plan, accountability and ongoing mentor access." },
];

export default function ForwardHowItWorks() {
  return (
    <Page>
      <Seo title="How Forward Works · Mentorship in 5 Steps" description="Five steps from 'where am I?' to 'I know where I'm going.' — how MindDhara Forward mentorship works." />
      <section className="md-section md-page-hero" data-testid="forward-hiw-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4">Forward · How It Works</div>
          <h1 className="text-5xl md:text-6xl font-serif mb-6 max-w-3xl mx-auto">
            Five steps from &ldquo;where am I?&rdquo; to<br />&ldquo;I know where I&apos;m going.&rdquo;
          </h1>
        </div>
      </section>
      <section className="md-section pt-0">
        <div className="md-container">
          <div className="mb-12 text-center">
            <h2 className="text-3xl md:text-4xl font-serif" data-testid="forward-hiw-how-we-help">How we help</h2>
          </div>

          <div className="grid md:grid-cols-5 gap-4 mt-2">
            {steps.map((s) => (
              <div key={s.num} className="md-card">
                <div className="wordmark text-3xl" style={{ color: "var(--md-accent)" }}>{s.num}</div>
                <h3 className="text-lg font-serif mt-3">{s.title}</h3>
                <p className="mt-2 text-xs" style={{ color: "var(--md-text-soft)" }}>{s.desc}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-3 mt-12 justify-center">
            <Link to="/find-a-mentor?source=forward-hiw-footer" className="btn-primary" data-testid="forward-hiw-browse">Browse Mentors <ArrowRight size={14} weight="bold" /></Link>
            <Link to="/forward/packages?source=forward-hiw-footer" className="btn-outline" data-testid="forward-hiw-packages">Explore Programmes</Link>
          </div>
        </div>
      </section>
    </Page>
  );
}
